import { cn } from "@/lib/utils"

export type ChatHeaderProps = React.ComponentProps<"header">

export function ChatHeader({ children, className, ...props }: ChatHeaderProps) {
  return (
    <header
      className={cn(
        // pointer-events-none so the absolute-positioned header doesn't
        // swallow wheel/click events over the chat body below. Re-enable
        // pointer-events only on actual interactive descendants (buttons,
        // links, role=button) — NOT on layout wrappers, which would otherwise
        // capture wheel events in their empty flex gaps and prevent the chat
        // from scrolling when the cursor is hovering near the top.
        "pointer-events-none flex w-full justify-end bg-transparent p-2",
        "[&_[data-slot=badge]]:pointer-events-auto [&_[role=button]]:pointer-events-auto [&_a]:pointer-events-auto [&_button]:pointer-events-auto [&_input]:pointer-events-auto",
        className
      )}
      {...props}
    >
      {children}
    </header>
  )
}
